import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider, ThemeProvider } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import DeleteContentNav from './DeleteContentNav';
import AddContentNav from './AddContentNav';
import UpdateContentNav from './UpdateContentNav';
import MessageBox from "../../../components/MessageBox/MessageBox";
import { green, red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const ContentNav = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [openEditModal, setOpenEditModal] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//Button Group
	const anchorRef = React.useRef(null);
	const [selectedIndex, setSelectedIndex] = React.useState(1);
	const [btnDisabled, setBtnDisabled] = useState(true);
	//

	const [mainNav, setMainNav] = useState([]);

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
		dataFilter();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	//search button
	const dataFilter = async () => {
        	await axios.get(
            process.env.REACT_APP_API_URL+'get_content_nav_table', {
			}).then(function (res) {
				setPosts(res.data.data);
		  	}).catch(function (error) {	
				console.log(error);
	  		});
    }

	const data = async () => {
		setDataLoaded(true);
		await axios.get(process.env.REACT_APP_API_URL+'get_main_nav_table', {
		}).then(function (res) {
			setMainNav(res.data.data);
		  }).catch(function (error) {	
			console.log(error);
		  });
	};

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const theme = createMuiTheme({
		palette: {
		  primary: green,
		},
	  });

	const showModal = (message, type) => {
			setShowMsgBox(true);
			setMsgType(type); //success or warning
			setMsg(message);
			//dataFilter();
			setTimeout(() => {
				setShowMsgBox(false);
				dataFilter();
			}, 2000)
	};

	const getMuiTheme = () => createMuiTheme({
		// overrides: {
		//   MUIDataTableHeadCell: {
		// 	root: {
		// 	  '&:nth-child(1)': {
		// 			width: 600
		// 		  },	
		// 	  '&:nth-child(2)': {
		// 		width: 600
		// 	  },
		// 	  '&:nth-child(3)': {
		// 		width: 250
		// 	  },
		// 	}
		//   }
		// }
	  });

	const columns = [
		{
			name: "id",
			label: "ID",
			options:{
				sort:true,
				filter:true,
			}
		},
		{
			name: "cn_url",
			label: "URL",
			options:{
				sort:true,
				filter:true,
			}
		},
		{
			name: "cn_name",
			label: "Name",
			options:{
				sort:true,
				filter:true,
			}
		},
		{
			name: "cn_description",
			label: "Description",
			options:{
				sort:true,
				filter:true,
			}
		},
		{
			name: "main_nav_desc",
			label: "Main Navigation",
			options:{
				sort:true,
				filter:true,
			}
		},
		{
			name: "",
			label:"Actions",
			options: {
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let id = posts[dataIndex].id;
					let cn_url = posts[dataIndex].cn_url;
					const cn_details = {
						cn_id: id,
						cn_url:  posts[dataIndex].cn_url,
						cn_name: posts[dataIndex].cn_name,
						cn_description: posts[dataIndex].cn_description,
						cn_fkey: posts[dataIndex].cn_fkey,
						cn_hasline: posts[dataIndex].cn_hasline,
					};
                            return (
                                <Grid container spacing={1}>
                                    <Grid item xs={12} lg={12} xl={5}>
											<UpdateContentNav mainNav={mainNav} cn_details={cn_details} showModal={showModal}/>
                                    </Grid>
                                    <Grid item xs={12} lg={12} xl={6}>
											<DeleteContentNav cn_id={id} cn_name={cn_url} showModal={showModal}/>
                                    </Grid>
                                </Grid>
                            );
			  },
			  download: false //exclude this column in csv export
			}
		}
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},downloadOptions: {
			filename : 'ContentNav.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};


	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/settings"}><h4 style={{color:"#339933"}}>Settings</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Content Navigation</h4>
			</div>
			<div className="page-container">
				{/* <AddSystemUser showModal={showModal}/> 
				<UpdateSystemUser user_id={user_id} user_details={user_details} showModal={openEditModal}/>
				<DeleteSystemUser user_id={user_id} user_fullname={user_fullname} showModal={openDeleteModal}/>  paste the <Fade></Fade> codes here instead and control them with openEditModal/openDeleteModal */}
				<div style={style}>
					<Grid container spacing={1}>
						<Grid item xs={12} xl={12} style={{ display: "flex", justifyContent: "flex-end" }}>
							{/* <AddSystemUser showModal={showModal}/> */}
							<Button style ={{marginTop: "22px", marginLeft:"10px", backgroundColor:"#339933",color:"#fff"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
								{/* Main Nav will be in its seperate module */}
								{/* <Button style ={{marginTop: "22px", marginLeft:"10px", color:"#fff"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Add Main Nav</Button> */}
								<AddContentNav showModal={showModal}/>			
						</Grid>
					</Grid>				
				</div>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
							
									<div className="table-title">
									Content Navigation
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
					</MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default ContentNav;
